import { createStripeAccount } from 'api/stripe';
import { userShape } from 'helpers/shared_types';
import { useState } from 'react';
import classnames from 'classnames';

import { ReactComponent as WarningSVG } from '../../icons/warning.svg';
import { ReactComponent as LoaderSVG } from '../../icons/loader.svg';

import './stripe_info.scss';

const StripeInfo = ({ user }) => {
  const { role, stripeId, detailsSubmitted, chargesEnabled } = user;

  if (role !== 'doctor' && role !== 'technician') return null;

  if (stripeId && detailsSubmitted && chargesEnabled) return null; // No need to show anything if everything is fine
  const warning = !stripeId || (!detailsSubmitted && !chargesEnabled);
  const attention = stripeId && detailsSubmitted && !chargesEnabled;

  const wrapperClasses = classnames(
    'stripe-info-wrapper w-100 mih25 flex flex-row pa4 mt5',
    {
      warning,
      attention,
    },
  );

  return (
    <div className={wrapperClasses}>
      <div className="flex-auto flex-grow-0 pa2">
        <WarningSVG />
      </div>
      <div className="flex-auto flex flex-column justify-between pa1">
        {warning && <TextWarning />}
        {attention && <TextAttention />}
      </div>
      {warning && <LinkWarning />}
      {attention && <LinkAttention />}
    </div>
  );
};

StripeInfo.propTypes = {
  user: userShape.isRequired,
};

const TextWarning = () => (
  <>
    <div className="fw5 red-d3">Your Stripe account is not set up!</div>
    <div className="red-d1 fw3">
      To accept payments, you should create a Stripe account and get verified by
      Stripe.
    </div>
  </>
);

const TextAttention = () => (
  <>
    <div className="fw5 orange-d3">Your Stripe account is being verified!</div>
    <div className="orange-d1 fw3">
      Stripe may contact you to gather additional information. Once your account
      is verified, you will be able to accept payments.
    </div>
  </>
);

const LinkWarning = () => {
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const { url } = await createStripeAccount();
    window.location.replace(url);
  };

  return (
    <div
      className="flex-auto self-center flex-grow-0 fw5 red-d3 pointer dim-lite"
      onClick={handleClick}
    >
      {loading ? <LoaderSVG className="loader" /> : 'Set up Stripe →'}
    </div>
  );
};

const LinkAttention = () => {
  return (
    <div className="flex-auto self-center flex-grow-0 fw5 dim-lite">
      <a href="https://dashboard.stripe.com/" target="_blank" rel="noreferrer">
        Go to Stripe Dashboard →
      </a>
    </div>
  );
};

export default StripeInfo;
